import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Coins, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useTalk, tkErr } from "./TalkLayout";

export default function TipSheet({ to: fixedTo, members, chatId, onClose }) {
  const { me, reloadMe } = useTalk();
  const [shop, setShop] = useState(null);
  const [coins, setCoins] = useState(25);
  const [busy, setBusy] = useState("");
  const [to, setTo] = useState(fixedTo);
  useEffect(() => { api.get("/talk/shop").then((r) => setShop(r.data)); }, []);
  const send = async (gift) => {
    const key = gift ? gift.id : "tip";
    setBusy(key);
    try {
      await api.post("/talk/tip", { to_user_id: to.user_id, coins: gift ? 0 : Number(coins), gift_id: gift?.id || null, chat_id: chatId, client_tx_id: crypto.randomUUID() });
      toast.success(gift ? `${gift.emoji} ${gift.name} sent to ${to.display_name}` : `Tipped ${coins} coins`);
      reloadMe(); onClose();
    } catch (e) { tkErr(e); }
    setBusy("");
  };
  return (
    <div className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center" onClick={onClose}>
      <div className="w-full max-w-md bg-[#111119] border border-white/10 rounded-t-3xl sm:rounded-3xl p-5" onClick={(e) => e.stopPropagation()} data-testid="talk-tip-sheet">
        <div className="flex items-center justify-between">
          <div className="font-heading font-black text-xl">{to ? `Send to ${to.display_name}` : "Who's it for?"}</div>
          <button onClick={onClose} data-testid="talk-tip-close"><X className="w-5 h-5 text-white/50" /></button>
        </div>
        <div className="mono text-xs text-[#FFE300] mt-1 flex items-center gap-1" data-testid="talk-tip-balance"><Coins className="w-3.5 h-3.5" />{me.coins} coins · <Link to="/talk/wallet" className="underline" onClick={onClose}>Top up</Link></div>
        {members && (
          <div className="flex gap-2 overflow-x-auto mt-3 pb-1" data-testid="talk-tip-recipients">
            {members.map((m) => (
              <button key={m.user_id} onClick={() => setTo(m)} data-testid={`talk-tip-to-${m.username}`}
                className={`shrink-0 rounded-full pl-1 pr-3 py-1 text-xs font-bold flex items-center gap-1.5 border ${to?.user_id === m.user_id ? "border-[#FFE300] bg-[#FFE300]/15" : "border-white/10"}`}>
                <span className="w-6 h-6 rounded-full bg-white/10 flex items-center justify-center overflow-hidden">{m.avatar_url ? <img src={m.avatar_url} alt="" className="w-full h-full object-cover" /> : m.display_name[0]}</span>{m.display_name}
              </button>
            ))}
          </div>
        )}
        <div className={`mt-4 grid grid-cols-4 gap-2 ${to ? "" : "opacity-40 pointer-events-none"}`}>
          {(shop?.gifts || []).map((g) => (
            <button key={g.id} onClick={() => send(g)} disabled={!!busy} data-testid={`talk-gift-${g.id}`}
              className="rounded-2xl bg-white/5 hover:bg-white/10 hover:-translate-y-0.5 transition-transform py-3 flex flex-col items-center disabled:opacity-50">
              <span className="text-3xl">{busy === g.id ? <Loader2 className="w-7 h-7 animate-spin" /> : g.emoji}</span>
              <span className="text-[11px] font-bold mt-1">{g.name}</span>
              <span className="mono text-[10px] text-[#FFE300]">{g.price}</span>
            </button>
          ))}
        </div>
        <div className="mt-5 flex items-center gap-2">
          <input type="number" min={1} max={5000} value={coins} onChange={(e) => setCoins(e.target.value)} data-testid="talk-tip-amount"
            className="flex-1 bg-white/5 border border-white/10 rounded-full px-4 py-2.5 outline-none mono" />
          <button onClick={() => send(null)} disabled={!!busy || !(coins >= 1) || !to} data-testid="talk-tip-send"
            className="bg-[#FFE300] text-black font-black rounded-full px-5 py-2.5 disabled:opacity-50">{busy === "tip" ? "Sending…" : "Tip coins"}</button>
        </div>
        <p className="text-[11px] text-white/40 mt-3">Tips and gifts go straight to their Jixxeo wallet and can be cashed out.</p>
      </div>
    </div>
  );
}
